import React, { createContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import pickBy from 'lodash.pickby';
import identity from 'lodash.identity';

export const FiltrosContext = createContext({
  filtros: {},
  setFiltros: () => {},
  visible: false,
  toggle: () => {},
});

export const FiltrosContextProvider = ({ children }) => {
  const [filtros, setFiltros] = useState([]);
  const [visible, setVisible] = useState(true);

  const transformFiltros = useCallback((props, labels) => {
    const validProps = pickBy(props, identity);

    setFiltros(Object.keys(validProps).map((key) => {
      const label = labels[key] || 'Filtro desconhecido';
      return { label, value: validProps[key] };
    }));
  }, [setFiltros]);

  const toggleVisible = useCallback(() => setVisible((oldValue) => !oldValue), [setVisible]);

  return (
    <FiltrosContext.Provider value={{
      filtros,
      setFiltros: transformFiltros,
      visible,
      toggle: toggleVisible,
    }}
    >
      {children}
    </FiltrosContext.Provider>
  );
};

FiltrosContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
